import { render, staticRenderFns } from "./SecurityPassword.vue?vue&type=template&id=55a8f48d&lang=pug&"
import script from "./SecurityPassword.vue?vue&type=script&lang=js&"
export * from "./SecurityPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports